export default __webpack_public_path__ + "static/media/logo.ba4a9464.png";